import {TimelineMax, Linear, Sine} from 'gsap';
const _initLottie = require('../utils/InitLottie');

module.exports = (data, el) => {
    const Behavior = {
        el: el
    };

    const _init = function(behavior, data) {
        const anim = _initLottie(data, behavior.el);

        behavior._tl = new TimelineMax();
        behavior._tl.to({frame: 0}, anim.getDuration(), {
            frame: anim.totalFrames - 1,
            onUpdate: function() {
                anim.goToAndStop(Math.round(this.target.frame), true);
                behavior._onEnterFrame();
            },
            ease: Linear.easeInOut
        });

        behavior._handleLoaded = () => {
            anim.removeEventListener('DOMLoaded', behavior._handleLoaded);
            delete behavior._handleLoaded;
        };

        behavior._onEnterFrame = () => {
            behavior._update();
            behavior.onUpdate();
        };

        behavior.play = () => {
            if (behavior._tweenTl) behavior._tweenTl.kill();
            behavior.__stopLoop();
            // if (!behavior._started) anim.addEventListener('enterFrame', behavior._onEnterFrame);
            behavior._started = true;
            behavior._tl.play();
        };

        behavior.gotoAndStop = frame => {
            if (behavior._tweenTl) behavior._tweenTl.kill();
            behavior.__stopLoop();
            // if (!behavior._started) anim.addEventListener('enterFrame', behavior._onEnterFrame);
            behavior._started = true;
            behavior._tl.seek(frame);
        };

        behavior.playFromTo = (from, to) => {
            return new Promise(resolve => {
                if (behavior._tweenTl) behavior._tweenTl.kill();
                behavior.__stopLoop();
                // if (!behavior._started) anim.addEventListener('enterFrame', behavior._onEnterFrame);
                behavior._started = true;
                behavior._tl.tweenFromTo(from, to, {onComplete: resolve, onCompleteParams: [true]});
            });
        };

        behavior.tweenFromTo = (from, to, duration, ease) => {
            return new Promise(resolve => {
                if (behavior._tweenTl) behavior._tweenTl.kill();
                behavior.__stopLoop();
                // if (!behavior._started) anim.addEventListener('enterFrame', behavior._onEnterFrame);
                behavior._started = true;

                behavior._tweenTl = new TimelineMax();
                behavior._tweenTl.to({t: from}, duration, {
                    t: to,
                    onUpdate: function() {
                        behavior._tl.time(this.target.t);
                    },
                    onComplete: resolve,
                    onCompleteParams: [true],
                    ease: ease || Sine.easeOut
                });
            });
        };

        behavior.waitForLoopComplete = () => {
            return new Promise(resolve => {
                if (!behavior._loopMode) {
                    resolve();
                    return;
                }

                behavior._loopStop = true;
                behavior._loopStopResolve = resolve;
            });
        };

        behavior.loopFromTo = (from, to) => {
            if (behavior._tweenTl) behavior._tweenTl.kill();
            behavior.__stopLoop();
            // if (!behavior._started) anim.addEventListener('enterFrame', behavior._onEnterFrame);
            behavior._started = true;
            behavior._loopMode = true;
            behavior._loopStop = false;
            behavior._loopTl = behavior._tl.tweenFromTo(from, to, {
                onComplete: (from, to) => {
                    if (behavior._loopStop) {
                        if (behavior._loopTl) {
                            behavior._loopTl.kill();
                            behavior._loopTl = null;
                        }
                        behavior._loopMode = false;
                        behavior._loopStop = false;
                        behavior._loopStopResolve();
                        return;
                    }

                    behavior.loopFromTo(from, to);
                },
                onCompleteParams: [from, to]
            });
        };

        behavior.__stopLoop = () => {
            if (behavior._loopTl) {
                behavior._loopTl.kill();
                behavior._loopTl = null;
            }
            behavior._loopMode = false;
            behavior._loopStop = false;
            behavior._loopStopResolve = undefined;
        };

        behavior.stop = () => {
            if (behavior._tweenTl) behavior._tweenTl.kill();
            behavior.__stopLoop();
            behavior._tl.pause();
            // anim.removeEventListener('enterFrame', behavior._onEnterFrame);
            behavior._started = false;
            behavior._loopMode = false;
            behavior._loopStop = false;
            behavior._loopStopResolve = undefined;
        };

        behavior.destroy = () => {
            if (behavior._tweenTl) behavior._tweenTl.kill();
            behavior.__stopLoop();
            behavior._tl.kill();
            behavior.el.innerHTML = '';
            // anim.removeEventListener('enterFrame', behavior._onEnterFrame);
            behavior._started = false;
            behavior._loopMode = false;
            behavior._loopStop = false;
            behavior._loopStopResolve = undefined;
        };

        anim.addEventListener('DOMLoaded', Behavior._handleLoaded);
    };

    Behavior.init = () => {
        _init(Behavior, data);
    };
    Behavior.play = () => {};
    Behavior.gotoAndStop = () => {};
    Behavior.playFromTo = () => {};
    Behavior.waitForLoopComplete = () => {};
    Behavior.loopFromTo = () => {};
    Behavior.stop = () => {};
    Behavior.destroy = () => {};
    Behavior._update = () => {};
    Behavior.onUpdate = () => {};

    return Behavior;
};
